"use client";

import { AlertTriangle } from "lucide-react";

export function MapConfigurationError() {
	return (
		<div className="flex items-center justify-center h-64 bg-red-50 rounded-lg border border-red-200">
			<div className="text-center p-6">
				<div className="text-red-500 mb-4">
					<AlertTriangle className="w-12 h-12 mx-auto" />
				</div>
				<h3 className="text-lg font-semibold text-red-900 mb-2">Map Configuration Error</h3>
				<p className="text-sm text-red-700 mb-4">
					The Google Maps API is not properly configured. Please check your API key and domain settings.
				</p>
				<div className="text-xs text-red-600 text-left">
					<p className="font-semibold mb-2">Common issues:</p>
					<ul className="list-disc list-inside space-y-1">
						<li>Missing or invalid API key</li>
						<li>API key not enabled for required services</li>
						<li>Domain not authorized for this API key</li>
						<li>API quota exceeded</li>
					</ul>
				</div>
			</div>
		</div>
	);
}

export function MapNetworkError({ retry }: { retry?: () => void }) {
	return (
		<div className="flex items-center justify-center h-64 bg-yellow-50 rounded-lg border border-yellow-200">
			<div className="text-center p-6">
				<div className="text-yellow-500 mb-4">
					<AlertTriangle className="w-12 h-12 mx-auto" />
				</div>
				<h3 className="text-lg font-semibold text-yellow-900 mb-2">Network Error</h3>
				<p className="text-sm text-yellow-700 mb-4">
					Unable to connect to the map service. Please check your internet connection.
				</p>
				{retry && (
					<button
						onClick={retry}
						className="px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 transition-colors text-sm"
					>
						Retry Connection
					</button>
				)}
			</div>
		</div>
	);
}
